import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Login from '../../Login/Login';
import { AuthContext } from '../../UserContext';

const Header = () => {

  const { user, signOutUser } = useContext(AuthContext)

  // console.log(user?.photoURL);

  const navigate = useNavigate()

  // console.log(user);

  const handleLogOut = () =>{
    signOutUser()
    .then(
      navigate('/login')
    )
    .catch(error => console.error(error))
  }


  return (
    <header aria-label="Site Header" className="bg-white border-b-2">
      <div
        className="mx-auto flex h-16 max-w-screen-xl items-center gap-8 "
      >
        <Link to={'/'} className='text-2xl font-semibold'><span className='bg-blue-600 px-3 py-1 rounded-md text-white'>Dr.</span><span className='pl-1 text-blue-600'>News</span></Link>
              <h2 className='hidden md:block text-xl font-semibold text-blue-600 lg:ml-32'>Welcome to Dragon News :)</h2>

        <div className="flex flex-1 items-center justify-end md:justify-between">
          <nav aria-label="Site Nav" className="hidden md:block">
            <ul className="flex items-center gap-6 text-sm">



            </ul>
          </nav>

          <div className="flex items-center gap-4">
            <div className="sm:flex sm:gap-4">
              
              {
                user && user.uid?
                <div className='flex items-center'>
                <button 
                onClick={handleLogOut}
                className="hidden rounded-md bg-blue-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-700 transition sm:block"
                >
                LogOut
                </button>
                <img src={user?.photoURL} alt="" className='w-10 h-10 ml-6 rounded-full' />
                </div>
                :
                <>
                <Link to={'/login'}
                  className="hidden rounded-md bg-blue-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-700 transition sm:block"
                >
                  Login
                </Link>
                <Link to={'/register'}
                  className="hidden rounded-md bg-gray-100 px-5 py-2.5 text-sm font-medium text-blue-600 hover:text-white transition hover:bg-blue-600 sm:block"
                >
                  Register
                </Link>
                </>
              }
            </div>

            
          </div>
        </div>
      </div>
    </header>

  );
};

export default Header;